/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/href-no-hash */
/* eslint-disable camelcase */
import React, { Component } from "react";
import moment from "moment";
import { Button } from "reactstrap";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import WeekPicker from "components/customDateTimePicker/CustomDateTimePicker";
import { NotificationContainer, NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import * as actions from "actions";
import DropdownSelect from "components/DropdownSelect";
import DropdownSelect1 from "components/DropdownSelect1";
import DropdownSelect2 from "components/DropdownSelect2";
import ErrorBoundary from "components/ErrorBoundary";
import Layout from "layout/Layout";
import IntlMessages from "util/IntlMessages";
import ReactDOM from 'react-dom';

let id;
let urlId;

const BookAppointmentModal = React.lazy(() => import("./BookAppointmentModal"));

class BookAppointment extends Component {
  state = {
    service: [],
    serviceId: "",
    employeeSelected: [],
    modal: false,
    from: "",
    to: "",
    idsWithName: [],
    formState: false,
    selected: false,
    serviceData: [],
    categoryId: null,
  };

  componentDidMount() {
    this.props.dateChange("");
    id = this.props.history.location.pathname;
    while (id.charAt(0) === "/") {
      id = id.substr(1);
      urlId = id;
      urlId = urlId.split("/")[0];
    }
    // if(this.props.business_slug != urlId) {
    this.props.getPageDetails(urlId);
    // }
    const splitTitle = urlId.split("-");
    let finalTitle = "";
    splitTitle.forEach(title => {
      finalTitle = `${finalTitle} ${title.charAt(0).toUpperCase()}${title.slice(1)}`;
    });
    this.props.changePageTitle(`Book an appointment at ${finalTitle} | Vibo Vibo`);
    ReactDOM.findDOMNode(this).scrollIntoView();
  }

  componentWillUnmount() {
    this.props.bookAppointmentReset();
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      formState: true,
    });
    this.props.saveDataOfForm("");
    this.props.changeModalScreen(1);
  };

  dayChange = selectedDate => {
    this.props.dateChange(moment(selectedDate).format("YYYY-MM-DD"));
  };

  handleChange = event => {
    if (event.target.name === "serviceId") {
      this.setState({ selected: true });
      this.fillEmployessID(event.target);
    }
    if (event.target.name === "employeesID") {
      const employeeSelected = this.props.employeesOfService.filter(
        item => item._id === event.target.value
      );
      if (event.target.value === "noPreference") {
        this.setState({ employeeSelected: [{ _id: "noPreference" }], selected: true });
      } else {
        this.setState({ employeeSelected, selected: true });
      }
    }
    if (event.target.name === "categoryId") {
      this.fillServicesID(event.target)
    }
  };

  fillServicesID = ({name, value}) => {
    let serviceData = this.props.services.filter(item => item.category._id == value);
    this.setState({serviceData, categoryId: value});
  }

  fillEmployessID = ({ name, value }) => {
    const service = this.props.services.filter(item => item._id === value);

    if (service.length !== 0) {
      const temp = service[0].employee.filter(item => item.enabled !== false);

      const employeesOfService = temp.map(item => {
        const { _id, firstname, lastname } = item;
        return {
          _id,
          firstname,
          lastname,
        };
      });
      this.props.employeeSelect(employeesOfService);
    }

    let { employeeSelected } = this.state;
    employeeSelected =
      employeeSelected.length !== 0 && employeeSelected[0]._id === "noPreference"
        ? employeeSelected
        : [];

    this.setState({
      [name]: value,
      service,
      employeeSelected,
      // selected: false,
    });
  };

  modalHeaderDataCall = () => {
    const service = this.props.services.filter(item => item._id === this.state.serviceId);
    return service;
  };

  modalOpenCall = () => {
    if (
      this.props.date &&
      this.state.selected === true &&
      this.props.employeesOfService.length !== 0 &&
      this.state.employeeSelected.length !== 0
    ) {
      this.toggle();
      const from = moment(this.props.date)
        .startOf("isoWeek")
        .format("YYYY-MM-DD")
        .toString();
      const to = moment(this.props.date)
        .endOf("isoWeek")
        .format("YYYY-MM-DD")
        .toString();

      let { employeeSelected } = this.state;
      if (employeeSelected[0]._id !== "noPreference") {
        employeeSelected = employeeSelected.map(item => item._id);
      } else {
        employeeSelected = this.props.employeesOfService.map(item => item._id);
      }
      const serviceSelected = this.state.serviceId;
      const branch = this.props.idForServices;
      this.props.modalEmployeeAndService({ serviceSelected, employeeSelected });
      this.props.getTime({ from, to, employeeSelected, serviceSelected, branch });
      this.props.setFrom(from);
      this.setState({ from, to, idsWithName: employeeSelected });
    } else if (this.state.selected === false && this.props.date === "") {
      NotificationManager.error("Please Select Date, Category, Service and Service Provider");
    } else if (this.props.date === "") {
      NotificationManager.error("Please Select Date");
    } else if(this.state.categoryId == null) {
      NotificationManager.error("Please Select Category");      
    } else if (this.state.selected === false) {
      NotificationManager.error("Please Select Service");
    } else if (this.props.employeesOfService.length === 0) {
      NotificationManager.error("Currently this service has no employees");
    } else if (this.state.employeeSelected.length === 0) {
      NotificationManager.error("Please Select Service Provider");
    }
  };

  handleBackClick = () => {
    let id = this.props.history.location.pathname;
    let businessName;
    while (id.charAt(0) === "/") {
      id = id.substr(1);
      businessName = id;
      businessName = businessName.split("/")[0];
    }
    this.props.history.push(`/${businessName}`);
  };

  render() {
    const user = JSON.parse(localStorage.getItem('user-data'));
    const { userDetail } = this.props;
    if (this.props.appointmentData != "" && (user || userDetail != '') && !this.state.modal) {
      this.props.dateChangeClick(this.props.date);
      this.props.timingSelectClick(this.props.from);
      this.props.setEmployeeId(this.props.appointmentData.employeeId);
      // this.props.chanegModal(4);
      const bookingInfoData = {
        fullName: this.props.employeeFullName,
        shortName: this.props.employeeShortName,
        day: moment(this.props.appointmentData.date).format("dddd"),
        date: moment(this.props.appointmentData.date).format("MMMM DD"),
        year: moment(this.props.appointmentData.date).format("YYYY"),
        timeRange: ` ${this.props.appointmentData.date}-${moment(this.props.appointmentData.from, [
          "h:mm A",
        ])
          .add(this.props.appointmentData.service[0].duration, "seconds")
          .format("h:mm A")}`,
      };

      this.props.appointmentDetailsFill(bookingInfoData);
      if ((user && user.role.name == 'Customer') || userDetail != '') {
        const toTime = moment(this.props.appointmentData.from, ["h:mm A"])
          .add(this.props.appointmentData.service[0].duration, "seconds")
          .format("HH:mm");
        const appointmentPayload = {
          firstName: user ? user.firstname : userDetail.firstname,
          lastName: user ? user.lastname : userDetail.lastname,
          email: user ? user.email : userDetail.email,
          phoneNumber: user ? user.phonenumber : userDetail.phonenumber,
          message: "none",
          termsConditions: true,
          employeeId: this.props.appointmentData.employeeId,
          serviceId: this.props.appointmentData.serviceId,
          duration: this.props.appointmentData.service[0].duration / 60,
          price: this.props.appointmentData.service[0].price,
          from: `${this.props.appointmentData.date} ${moment(this.props.appointmentData.from, [
            "h:mm A",
          ]).format("HH:mm")}`,
          to: `${this.props.appointmentData.date} ${toTime}`,
          location: this.props.appointmentData.location,
          businessname: this.props.appointmentData.businessname,
        }
        this.props.bookAppointmentCustomer(appointmentPayload);
        this.props.changeModalScreen(4);
      } else {
        this.props.changeModalScreen(3);
      }
      this.setState({ modal: true });
    }
    moment.locale("en");
    const weekDays = {
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
    };
    const disableDays = [];
    Object.keys(this.props.operations).forEach(day => {
      disableDays.push(weekDays[day]);
    });

    const presents = _.differenceWith([0, 1, 2, 3, 4, 5, 6], disableDays, _.isEqual);

    const uniqueResults = [];
    this.props.services.filter(function (item) {
      var i = uniqueResults.findIndex(x => x._id==item.category._id);
      if (i <= -1) {
        uniqueResults.push(item.category);
      }
      console.log("CAT",uniqueResults);
      
      return null;
    });

    return (
      <ErrorBoundary>
        <Layout>
          <div className="h-75">
            <Helmet>
              <title> {this.props.pageTitle}</title>
            </Helmet>
            <div className="row page-navigate-text vibo-container pl-5">
              <div
                className="col-xl-3 col-md-4 col-sm-6 col-12 pointer"
                onClick={this.handleBackClick}
              >
                <i className="zmdi zmdi-chevron-left zmdi-hc-fw" />
                <span>Back To {this.props.businessName}</span>
              </div>
            </div>

            <div className="common-container">
              <div className="row page-header-text">
                <div className="col-12">
                  <h2 className="mb-4 font-size-20">Book an Appointment</h2>
                </div>
              </div>
              <div className="row dropdown-row">
                <div className="col-md-2">
                  <WeekPicker
                    handleChange={this.dayChange}
                    name="date"
                    disabledDays={presents}
                    selectedDate={this.props.date}
                  // inputProps={{ readOnly: "true" }}
                  />
                </div>
                <div className="col-md-2">
                  <DropdownSelect1
                    category={uniqueResults}
                    handleChange={this.handleChange}
                    name="categoryId"
                  />
                </div>
                <div className="col-md-2">
                  <DropdownSelect
                    category={this.state.serviceData}
                    handleChange={this.handleChange}
                    name="serviceId"
                  />
                </div>
                <div className="col-md-2">
                  <DropdownSelect2
                    category={this.props.employeesOfService}
                    handleChange={this.handleChange}
                    name="employeesID"
                    serviceId={this.state.serviceId}
                    selected={this.state.selected}
                    employeeSelected={this.state.employeeSelected}
                  />
                </div>
                <div className="col-md-2">
                  <Button
                    className="btn-vibo2 jr-btn jr-btn-nw"
                    onClick={() => this.modalOpenCall()}
                  >
                    Check Availability
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <React.Suspense fallback={null}>
            <BookAppointmentModal
              toggle={this.toggle}
              modal={this.state.modal}
              service={this.state.service}
              from={this.state.from}
              to={this.state.to}
              ids={this.state.idsWithName}
              formState={this.state.formState}
              urlId={urlId}
              idForServices={this.props.idForServices}
              history={this.props.history}
              employeeSelected={this.state.employeeSelected}
            />
          </React.Suspense>
          <NotificationContainer />
        </Layout>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  pageTitle: state.changeTitle.pageTitle,
  title: state.business.name,
  employees: state.bookAppointment.employees_working,
  services: state.bookAppointment.services_offered,
  date: state.modal.dateSelected,
  employeesOfService: state.bookAppointment.employeesOfService,
  operations: state.bookAppointment.operations,
  businessName: state.bookAppointment.businessName,
  businessId: state.customerBooking.businessId,
  idForServices: state.bookAppointment.businesslocationId,
  business_slug: state.business.business_slug,
  business_locations: state.business.business_locations[0],
  appointmentData: state.modal.appointmentData,
  userDetail: state.login.userDetail,
});

const mapDispatchToProps = dispatch => ({
  // findServices: id => dispatch(actions.getAllServices(id)),
  getTime: payload => dispatch(actions.getTimeSlots(payload)),
  dateChange: date => dispatch(actions.dateChangeClick(date)),
  employeeSelect: employeeSelected => dispatch(actions.setEmployeeSelected(employeeSelected)),
  modalEmployeeAndService: payload => dispatch(actions.setEmployeesAndServiceIds(payload)),
  setFrom: from => dispatch(actions.setFrom(from)),
  changeModalScreen: id => dispatch(actions.chanegModal(id)),
  saveDataOfForm: payload => dispatch(actions.saveFormData(payload)),
  changePageTitle: payload => dispatch(actions.setTitleOfPage(payload)),
  getPageDetails: id => dispatch(actions.getIDs(id)),
  bookAppointmentReset: () => dispatch(actions.bookAppointmentReset()),
  dateChangeClick: date => dispatch(actions.dateChangeClick(date)),
  chanegModal: id => dispatch(actions.chanegModal(id)),
  timingSelectClick: timing => dispatch(actions.timingSelectClick(timing)),
  setEmployeeId: payload => dispatch(actions.setEmployeeId(payload)),
  appointmentDetailsFill: payload => dispatch(actions.setAppointmentEmployeeDtails(payload)),
  bookAppointmentCustomer: payload => dispatch(actions.bookCustomerAppointment(payload)),

  // getPageDetails: id => dispatch(actions.getBusinessPage(id)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BookAppointment)
);



// WEBPACK FOOTER //
// ./containers/BookAppointment.js